import { useState } from "react";
import validator from "validator";
import React from "react";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import ApiMethods from "../../../../ApiManager/ApiMethods";
import { requestForToken } from "../../../../firebase";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../../context/AlertContext";
import { menuLogo } from "../../../../brands";
import "./login.css";

const Login = ({
  handleToggle,
  checkAlert,
  handleForgotPassword,
  loginVerification,
  handleToggleRegisterNumber,
}) => {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [platform, setPlatform] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  const { showAlert, closeAlert } = useAlert();

  const onLogin = async (e) => {
    await requestForToken();

    setEmailError("");
    setPasswordError("");

    if (!validator.isEmail(email)) {
      setEmailError("Unesite ispravnu email adresu!");
      showAlert("Email nije u dobrom formatu", "error");
      return;
    }

    if (password === "") {
      setPasswordError("Unesite lozinku");
      showAlert("Morate popuniti polje za lozinku", "error");

      return;
    }

    if (password.length < 6) {
      setPasswordError("Lozinka mora imati najmanje 8 karaktera");
      return;
    }

    try {
      const data = {
        email,
        password,
        // token: localStorage.getItem("fcm_token"),
      };

      const response = await ApiMethods.post("auth/login", data);

      if (response.token) {
        localStorage.setItem("token", response.token);
        localStorage.setItem("id", response.id);
        localStorage.setItem("firstName", response.first_name);
        localStorage.setItem("lastName", response.last_name);
        localStorage.setItem("guid", response.guid);
        if (response.photo_url) {
          localStorage.setItem("photoUrl", response.photo_url);
        } else {
          localStorage.removeItem("photoUrl");
        }
        setToken(response.token);

        showAlert("Uspesno logovanje!", "success");

        loginVerification();
      } else {
        throw new Error("Token not found in response");
      }
    } catch (error) {
      showAlert("Greska pri prijavljivanju", "error");
      setEmailError("Pogresni podaci za prijavu");
      setPasswordError("Pogresni podaci za prijavu");
      console.error("Error during login:", error);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      onLogin(event);
    }
  };

  const validateEmail = (e) => {
    setEmail(e.target.value);
  };

  const validatePassword = (e) => {
    setPassword(e.target.value);
  };

  const onkeydown = (event) => {
    if (event.key === "Enter") {
      onLogin();
    }
  };

  // CRA's css-loader resolves a CSS `url(...)` as a module import, which can't reach anything
  // in /public (only %PUBLIC_URL% in index.html itself can) — this custom property carries the
  // actual `url(...)` in from here instead, so login.css's own background rules (the gradient
  // fade + this photo, layered together) can just read it back via `var(--hf-login-photo)`.
  const loginPhotoStyle = {
    "--hf-login-photo": `url(${process.env.PUBLIC_URL}/img/login_picture.png)`,
  };

  return (
    <div className="hf-login-root" onKeyDown={onkeydown}>
      <div className="hf-login-shell">
        <div className="hf-login-brand" style={loginPhotoStyle}>
          <img className="hf-login-brand-logo" src={menuLogo} alt="Logo" />
          <div className="hf-login-brand-footer">
            <span className="hf-login-brand-tick" aria-hidden="true" />
            <h2 className="hf-login-brand-heading">
              Vođeni treninzi za rekreativce
            </h2>
            <p className="hf-login-brand-tagline">
              Bolja verzija tebe svakog dana
            </p>
          </div>
        </div>

        <div className="hf-login-card">
          <div className="hf-login-card-inner">
            <div className="hf-login-logo-wrap">
              <img className="hf-login-logo" src={menuLogo} alt="Logo" />
            </div>

            <h1 className="hf-login-title">Dobrodošli</h1>
            <p className="hf-login-subtitle">
              Prijavite se na svoj HitFit nalog
            </p>

            <div className="hf-login-form">
              <div className="hf-login-field">
                <label className="hf-login-label" htmlFor="email">
                  Email
                </label>
                <div
                  className={`hf-login-input-wrap${emailError ? " hf-login-input-error" : ""}`}
                >
                  <span className="hf-login-input-icon">
                    <MailOutlineIcon fontSize="small" />
                  </span>
                  <input
                    id="email"
                    value={email}
                    name="email"
                    type="email"
                    placeholder="Email"
                    required
                    onChange={validateEmail}
                  />
                </div>
                <p className="hf-login-error-text">{emailError}</p>
              </div>

              <div className="hf-login-field">
                <div className="hf-login-label-row">
                  <label className="hf-login-label" htmlFor="password1">
                    Lozinka
                  </label>
                  <button
                    type="button"
                    className="hf-login-forgot-link"
                    onClick={() =>
                      handleForgotPassword
                        ? handleForgotPassword()
                        : navigate("/forgot-password")
                    }
                  >
                    Zaboravili ste lozinku?
                  </button>
                </div>
                <div
                  className={`hf-login-input-wrap${passwordError ? " hf-login-input-error" : ""}`}
                >
                  <span className="hf-login-input-icon">
                    <LockOutlinedIcon fontSize="small" />
                  </span>
                  <input
                    id="password1"
                    name="password1"
                    type={showPassword ? "text" : "password"}
                    placeholder="Lozinka"
                    value={password}
                    required
                    onChange={validatePassword}
                    onKeyDown={handleKeyPress}
                  />
                  <button
                    type="button"
                    className="hf-login-toggle-visibility"
                    aria-label={
                      showPassword ? "Sakrij lozinku" : "Prikaži lozinku"
                    }
                    onClick={() => setShowPassword((v) => !v)}
                  >
                    {showPassword ? (
                      <VisibilityOff fontSize="small" />
                    ) : (
                      <Visibility fontSize="small" />
                    )}
                  </button>
                </div>
                <p className="hf-login-error-text">{passwordError}</p>
              </div>

              <label className="hf-login-remember-row" htmlFor="rememberMe">
                <input
                  id="rememberMe"
                  type="checkbox"
                  className="hf-login-checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <span>Zapamti me</span>
              </label>

              <button
                type="submit"
                className="hf-login-submit"
                onClick={onLogin}
              >
                Uloguj se
              </button>
            </div>

            {/* Mobile-only — Tablet/Desktop shows this same tick/heading (+ tagline) in the
                brand panel instead (.hf-login-brand-footer above), so this is hidden there. No
                tagline here specifically — by explicit request, so the photo below has more
                room to actually show instead of being squeezed by an extra line of text. */}
            <div className="hf-login-mobile-footer" style={loginPhotoStyle}>
              <span className="hf-login-brand-tick" aria-hidden="true" />
              <h2 className="hf-login-brand-heading">
                Vođeni treninzi za rekreativce
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
